import { render } from "./Photo_Display_mobile.vue?vue&type=template&id=232f165a&scoped=true"
import script from "./Photo_Display_mobile.vue?vue&type=script&lang=js"
export * from "./Photo_Display_mobile.vue?vue&type=script&lang=js"

import "./Photo_Display_mobile.vue?vue&type=style&index=0&id=232f165a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232f165a"]])

export default __exports__